export default __webpack_public_path__ + "static/media/list.fa86afcd.svg";